import BasicResource from '@/api/resource';

class Resource extends BasicResource {
    constructor () {
        super('postbacks');
    }

    list (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v1/postbacks',
            params: params,
        });
    }

    setDefault (id) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/postbacks/${id}/default`,
        });
    }

    update (data) {
        return this.client.request ({
            method: 'put',
            path: '/publisher/v1/postbacks',
            data: data,
        });
    }
}

export default new Resource;
